import { AdviseurMenu, AuthContext, ErrorPage, FeatureComponent, InvalidAdviesboxResultErrorPage, NavigationBar, Notificaties2Menu, NotificatiesMenu, PageLoading, SupportMenu, SupportRemoteAssistanceModal, SupportTicketModalAjax, useRequestInit } from "adviesbox-shared";
import React, { ReactElement, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import useAbortableFetch from "use-abortable-fetch";
import { OrganisatiesOutput, VestigingenOutput } from "../.generated/licenties/licentiestypes";
import UserDetailsContext from "../user-details/user-details-context";
import classes from "./TopNavbar.module.scss";
import "./TopNavbar.scss"
import { AppDataContext } from "../navigation/appdata-context";

const TopNavbar = (): ReactElement => {
  const { user } = useContext(AuthContext);
  const { activePage } = useContext(AppDataContext);
  const { userDetails } = useContext(UserDetailsContext);
  const { params, settings, requestInit } = useRequestInit();
  const { vestiging: vestigingId } = useParams<{ vestiging: string }>();
  const [showMeldingmaken, setShowMeldingMaken] = useState(false);
  const [showRemoteAssistance, setShowRemoteAssistance] = useState(false);
  const [showInvalidAdviesboxResultErrorPage, setShowInvalidAdviesboxResultErrorPage] = useState(false);

  const vestiging = useAbortableFetch<VestigingenOutput>(
    `${settings.licentiesOrigin}/Vestigingen/${vestigingId}`,
    requestInit
  );

  const organisatieId = userDetails.organisatieId ? userDetails.organisatieId : null;
  const organisatieUrl = organisatieId ? `${settings.licentiesOrigin}/Organisaties/${organisatieId}` : null;
  const organisatie = useAbortableFetch<OrganisatiesOutput>(organisatieUrl, requestInit);


  if (vestiging.error) {
    return <ErrorPage error={vestiging.error} />;
  }

  if (organisatie.error) {
    return <ErrorPage error={organisatie.error} />;
  }

  if (vestiging.loading || !vestiging.data || organisatie.loading || !organisatie.data) {
    return <PageLoading />;
  }

  const vestigingNaam =
    vestiging.data && typeof vestiging.data !== "string" && vestiging.data.isValid && params.vestiging
      ? vestiging.data.vestigingen?.[params.vestiging]?.naam
      : "";
  const organisatieNaam =
    organisatie.data && typeof organisatie.data !== "string" && organisatieId
      ? organisatie.data.organisaties?.[organisatieId].naam
      : "";

  if (showInvalidAdviesboxResultErrorPage) {
    return <InvalidAdviesboxResultErrorPage />;
  }

  if (!user) {
    return <ErrorPage error={new Error("user not logged in")} />;
  }

  return (
    <>
      <NavigationBar title={activePage}>
        <SupportMenu
          showMeldingMaken={() => setShowMeldingMaken(true)}
          showRemoteAssistance={() => setShowRemoteAssistance(true)}
          classes={{
            iconblack: classes.iconblack,
            iconpadding: classes.iconpadding
          }}
        />
        <FeatureComponent feature="FeatureNotificaties2">
          <Notificaties2Menu />
        </FeatureComponent>
        <FeatureComponent feature="FeatureNotificaties2" isDisabled>
          <NotificatiesMenu />
        </FeatureComponent>
        <AdviseurMenu vestigingNaam={vestigingNaam} organisatieNaam={organisatieNaam} />
      </NavigationBar>
      {/* istanbul ignore next */ showMeldingmaken && user && (
        <SupportTicketModalAjax
          adviesdossierId={params.adviesdossier ?? null}
          user={user}
          closeModal={() => setShowMeldingMaken(false)}
          showInvalidResultErrorPage={() => setShowInvalidAdviesboxResultErrorPage(true)}
          vestigingId={params.vestiging}
        />
      )}
      {/* istanbul ignore next */ showRemoteAssistance && (
        <SupportRemoteAssistanceModal closeModal={() => setShowRemoteAssistance(false)} />
      )}
    </>
  );
};

TopNavbar.displayName = "TopNavbar";

export default TopNavbar;
